import React from "react";
import moment from "moment-jalaali";
import "moment/locale/fa";

import "antd/dist/antd.min.css";
import { ConfigProvider } from "antd";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import Auth from "pages/auth";
import Dashboard from "pages/dashboard";
import {
  useHistory,
  BrowserRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
// import ProtectedRoute from "components/routes/ProtectedRoute";

function App() {
  // const Unauthorized = () => (
  //   <div>
  //     <p>خطای امنیتی</p>
  //     <a href="/">صفحه اصلی</a>
  //   </div>
  // );

  React.useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        if (
          window.confirm("ورژن جدیدی یافت شد، آیا مایل به تازه سازی هستید؟.")
        ) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
          window.location.reload();
        }
      },
    });
  }, []);

  let history = useHistory();
  moment.locale("fa"); // set the locale to Persian

  return (
    <BrowserRouter history={history}>
      <ConfigProvider direction="rtl">
        <div dir="rtl">
          <Switch>
            <Route path={"/auth"} component={Auth} />

            <Route path={"/dashboard"} component={Dashboard} />

            {/* <Route path={"/"} component={Main} /> */}
            <Redirect path={"/"} to={"/auth/login"} />
          </Switch>
        </div>
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
